var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
  'padding-bottom': !_vm.$vuetify.breakpoint.mdAndUp  ? '56px' : 'initial',
})},[(_vm.detailView)?_c('list-navigator',{style:({
       zIndex: _vm.$vuetify.breakpoint.mdAndUp ? 'initial': '10',
    }),attrs:{"backButtonHref":_vm.listViewQuery,"disabled":_vm.detail.loadingDetails,"total":_vm.list.list.length,"current":_vm.currentItemIndex},on:{"navigate":(idx) => _vm.viewItemDetails(idx)}}):_vm._e(),_c('router-view',_vm._b({ref:"view",on:{"request":_vm.request}},'router-view',_vm.viewData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }